import {Component, OnInit, Input, OnDestroy, Output, EventEmitter} from '@angular/core';
import {TaskService} from '../../services/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import {Subscription} from 'rxjs';
@Component({
  selector: 'nf-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit, OnDestroy {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  dropdownInputValue = ''; // 下拉组件输入框绑定值
  dropdownOption = []; // 下拉组件新增列表
  isDropdownOptionEdit = true; // 下拉组件选项是否可编辑
  isDisabled = false;
  selectedValue = [];
  tempLabels;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
    }
  }
  @Input('nfDisabled') set changeDisabled(val: boolean) {
    this.isDisabled = val;
  }
  @Output() updateFilterData: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit() {
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  // 下拉弹框显示/隐藏
  dropdownPopVisibleChange(visible) {
    // 打开时，将标签数据保存到临时对象中
    if (visible) {
      this.tempLabels = this.column.settings.labels;
    }
    // 关闭时，恢复数据以及状态
    if (!visible) {
      this.isDropdownOptionEdit = true;
      if (JSON.stringify(this.tempLabels) !== JSON.stringify(this.column.settings.labels)) {
        this.column.settings.labels = this.tempLabels;
      }
    }
  }
  // 下拉组件 关闭选中标签
  handleDropdownClose(removedLabel): void {
    this.pulse.columnValues[this.column.id].ids.splice
    (this.pulse.columnValues[this.column.id].ids.findIndex(v => v === removedLabel.id), 1);
    this.dropdownOption = [removedLabel, ...this.dropdownOption];
    this.patchDropdownPulseData();
  }
  // 下拉组件 限制标签文字长度
  sliceTagName(tag: string): string {
    const isLongTag = tag.length > 20;
    return isLongTag ? `${tag.slice(0, 20)}...` : tag;
  }
  // 下拉组件 处理新增标签
  handleDropdownInputConfirm(): void {
    // 输入框无值时不处理
    if (!this.dropdownInputValue) {
      return;
    }
    // 检查标签是否存在
    if (this.checkExist()) {
      this.message.info('该标签已经存在，无需重复添加!');
      return;
    }
    const maxId = this.getDropdownOptionId();
    const newOption = {
      'id': maxId,
      'name': this.dropdownInputValue.trim()
    };
    this.dropdownOption = [newOption, ...this.dropdownOption];
    this.column.settings.labels = [newOption, ...this.column.settings.labels];
    this.patchDropdownColumnData();
    this.dropdownInputValue = '';
  }

  checkExist(): boolean {
    let existFlag = false;
    if (this.column && this.column.settings && this.column.settings.labels) {
      for (const label of this.column.settings.labels) {
        if (label['name'].trim() === this.dropdownInputValue.trim()) {
          existFlag = true;
          break;
        }
      }
    }
    return existFlag;
  }
  // 下拉组件 新增选项触发选中
  handleDropdownOption(option) {
    if (!this.pulse.columnValues[this.column.id] || !this.pulse.columnValues[this.column.id]['ids']) {
      this.pulse.columnValues[this.column.id] = {
        ids: []
      }
    }
    // 判断当前标签是否已选择
    if (!this.pulse.columnValues[this.column.id].ids.includes(option.id)) {
      this.pulse.columnValues[this.column.id].ids.push(option.id);
      this.patchDropdownPulseData();
    }
  }
  // 开启标签编辑
  doEditDropdownLabels() {
    let pulses = this.boardData.boardData.pulses;
    this.selectedValue = [];
    for (let pulse of pulses) {
      let value = pulse.columnValues[this.column.id];
      if (value && value['ids']) {
        for (const id of value['ids']) {
          this.selectedValue.push(id);
        }
      }
    }
    this.tempLabels = JSON.parse(JSON.stringify(this.column.settings.labels));
    this.isDropdownOptionEdit = false;
  }

  submitDropdownLabelsChange() {
    this.isDropdownOptionEdit = true;
    this.patchDropdownColumnData();
  }

  dropdownLabelsChangeCancel() {
    if (JSON.stringify(this.tempLabels) !== JSON.stringify(this.column.settings.labels)) {
      this.column.settings.labels = this.tempLabels;
    }
    this.isDropdownOptionEdit = true;
  }
  // 下拉组件 删除新增选项
  doRemoveDropdownOption(i) {
    this.column.settings.labels.splice(i, 1);
  }
  // 获取下拉项最大ID
  getDropdownOptionId() {
    let maxId = 0;
    if (this.column && this.column.settings && this.column.settings.labels) {
      for (const label of this.column.settings.labels) {
        if (label['id'] > maxId) {
          maxId = label['id'];
        }
      }
    }
    return maxId + 1;
  }
  // 更新表头数据
  patchDropdownColumnData() {
    this.dataSubscription = this.taskService.doEditColumnHeader(this.boardData.id, this.column.id, this.column).subscribe((res: any) => {
    }, (err) => {
      this.message.create('error', '处理失败！');
    }, () => {
      this.tempLabels = JSON.parse(JSON.stringify(this.column.settings.labels));
    });
  }
  // 更新单元格数据
  patchDropdownPulseData() {
    const param = {
      'pulseIds': [this.pulse.id],
      'columnId': this.column.id,
      'columnValue': this.pulse.columnValues[this.column.id]
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardData.id, param).subscribe((res: any) => {
      this.updateFilterData.emit();
    }, (err) => {
      this.message.create('error', '处理失败！');
    });
  }
  // 获取所有已用ID
  getUserIds() {
    let useIds = [];
    this.boardPulseData.forEach((pulses, index) => {
      for (const item in pulses.columnValues) {
        if (pulses.columnValues.hasOwnProperty(item)) {
          if (pulses.columnValues[this.column.id].ids) {
            for (let i = 0; i < pulses.columnValues[this.column.id].ids.length; i++) {
              useIds.push(pulses.columnValues[this.column.id].ids[i]);
            }
          }
        }
      }
    });
    useIds = Array.from(new Set(useIds));
    return useIds;
  }
}
